import React, { useState } from 'react';

import { HeroContainer, HeroBg, VideoBg, HeroContent, HeroH1, HeroP, HeroBtnWrapper, ArrowForward, ArrowRight } from './HeroElements';
import Video from '../../videos/video.mp4';
import { Button } from '../ButtonElement';

const Hero = () => {

    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    }

    return (
        <HeroContainer>
            <HeroBg>
                <VideoBg autoPlay loop muted src={Video} type='video/mp4' />
            </HeroBg>
            <HeroContent>
                <HeroH1
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    whileHover={{scale: 1.2}}
                    transition={{ duration: 0.8 }}

                >Hi, I'm Ish Takkar.</HeroH1>
                <HeroP>Full Stack Web Developer, with a knack for Competitive Programming.</HeroP>
                <HeroBtnWrapper>
                    <Button
                        to="about" onMouseEnter={onHover} onMouseLeave={onHover} smooth={true} duration={500} spy={true} exact="true" offset={-80}>
                        Get to know me {hover ? <ArrowForward /> : <ArrowRight />}
                    </Button>
                </HeroBtnWrapper>
            </HeroContent>
        </HeroContainer>
    );
};

export default Hero;